
import { Check } from 'lucide-react';
import {
  DEVELOPMENT_STAGE_LABEL,
  DEVELOPMENT_STAGE_SHORT,
  DEVELOPMENT_STAGES,
  dayText,
  etaText,
  type TicketDevelopment,
} from '@/entities/ticket';
import { cn } from '@/shared/lib/cn';
import styles from './DevelopmentProgress.module.css';

interface Props {
  development: TicketDevelopment;
  note?: React.ReactNode;
  className?: string;
}

export function DevelopmentProgress({ development, note, className }: Props) {
  const current = DEVELOPMENT_STAGES.indexOf(development.stage);
  const eta = etaText(development);
  const sprint = development.sprint;
  return (
    <div className={cn(styles.root, className)}>
      <p className={styles.head}>
        <span className={styles.stage}>{DEVELOPMENT_STAGE_LABEL[development.stage]}</span>
        {eta && <span className={styles.eta}>{eta}</span>}
      </p>

      <ol className={styles.track} aria-label="Этапы разработки">
        {DEVELOPMENT_STAGES.map((stage, i) => {
          const state = i < current ? 'past' : i === current ? 'current' : 'future';
          return (
            <li
              key={stage}
              className={cn(styles.step, styles[`step-${state}`])}
              aria-current={state === 'current' ? 'step' : undefined}
            >
              <span className={styles.mark} aria-hidden>
                {state === 'past' && <Check size={10} strokeWidth={3} />}
              </span>
              <span className={styles.label}>{DEVELOPMENT_STAGE_SHORT[stage]}</span>
            </li>
          );
        })}
      </ol>

      {(sprint && development.stage !== 'done') || note ? (
        <p className={styles.note}>
          {sprint && development.stage !== 'done' && (
            <span>
              в плане на {dayText(sprint.startsOn)} — {dayText(sprint.endsOn)}
            </span>
          )}
          {note}
        </p>
      ) : null}
    </div>
  );
}
